var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WorkBoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M20,9c-0.552,0-1-0.447-1-1c0-1.654-1.346-3-3-3s-3,1.346-3,3c0,0.553-0.448,1-1,1s-1-0.447-1-1 c0-2.757,2.243-5,5-5s5,2.243,5,5C21,8.553,20.552,9,20,9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fad500",
    d: "M25,8H6v30h38v-6c0-4.971-4.029-9-9-9h-3.622c-2.506,0-4.625-1.855-4.956-4.339L25,8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d35230",
    d: "M20,22.5c0-2.586,4.054-3.675,6.388-4.089L25.667,13H6v19h22C28,25.5,20,27.464,20,22.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M6,38v2c0,1.105,0.895,2,2,2h4l2-2l2,2l2-2l2,2l2-2l2,2h4l2-2l2,2l2-2l2,2h6c1.105,0,2-0.895,2-2v-2 H6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WorkBoot);
export default __webpack_public_path__ + "static/media/icons8-work-boot.0d082beda3f28a025e60d756e7a6f0a2.svg";
export { ForwardRef as ReactComponent };